<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page bookings-ticket-page">
  <div class="bb-page-shell bookings-ticket-shell">

    <!-- Mobile Header -->
    <header class="bookings-mobile-header">
      <div class="bookings-header-copy">
        <span class="bb-eyebrow">
          {{ 'clientsbookings' | transloco }}
        </span>

        <h2>
          {{ 'clientsbookings' | transloco }}
        </h2>

        <p>
          {{ 'Manage today appointments and client requests' | transloco }}
        </p>
      </div>

      <div class="bookings-header-counter">
        <strong>{{ total || 0 }}</strong>
        <span>{{ 'Booking' | transloco }}</span>
      </div>
    </header>

    <!-- Search -->
    <div class="bookings-mobile-search">
      <div class="bookings-search-label">
        <i class="fa-solid fa-phone" aria-hidden="true"></i>
        <span>{{ 'phone' | transloco }}</span>
      </div>

      <div class="bookings-search-control">
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          class="bb-input"
          [(ngModel)]="searchKey"
          placeholder="{{ 'phone' | transloco }}"
          (input)="normalizePhoneInput()"
          (keydown.enter)="onEnterPressed()"
        />

        <button
          class="bb-btn bb-btn-primary"
          type="button"
          (click)="search()"
          [disabled]="contentReady"
        >
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          {{ 'Search' | transloco }}
        </button>
      </div>

      <button
        *ngIf="searched"
        class="bb-btn bb-btn-secondary bookings-clear-search"
        type="button"
        (click)="clearSearch()"
        [disabled]="contentReady"
      >
        <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
        {{ 'all data' | transloco }}
      </button>

      <div class="bookings-active-filter" *ngIf="searched">
        <span>{{ 'phone' | transloco }}</span>
        <strong>{{ searchKey }}</strong>
      </div>
    </div>

    <!-- Tickets -->
    <ng-container *ngIf="!noData; else noBookingsTemplate">

      <div class="booking-ticket-list">
        <article
          class="booking-ticket"
          *ngFor="let booking of allData; trackBy: trackByBookingId"
        >

          <!-- Top -->
          <div class="booking-ticket-top">
            <div class="booking-number-box">
              <span>{{ 'Booking' | transloco }}</span>
              <strong>#{{ booking.id }}</strong>
            </div>

            <div class="booking-ticket-status-area">
              <span
                class="bb-badge booking-status"
                [ngClass]="getStatusClass(booking.status)"
              >
                {{ getStatusLabel(booking.status) | transloco }}
              </span>

              <div
                class="bb-action-dropdown dropdown"
                *ngIf="hasBookingActions(booking)"
              >
                <button
                  class="bb-icon-btn"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-boundary="viewport"
                  aria-expanded="false"
                  [attr.aria-label]="'Actions' | transloco"
                  [title]="'Actions' | transloco"
                >
                  <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                </button>

                <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">

                  <ng-container *ngIf="!isFinalStatus(booking.status)">

                    <li *ngIf="booking.status != 1">
                      <button
                        class="bb-dropdown-item dropdown-item"
                        type="button"
                        (click)="setBookingStatus(booking, 1)"
                        [disabled]="isUpdatingStatus"
                      >
                        <i class="fa-solid fa-check" aria-hidden="true"></i>
                        {{ 'approved' | transloco }}
                      </button>
                    </li>

                    <li *ngIf="booking.status != 4">
                      <button
                        class="bb-dropdown-item dropdown-item"
                        type="button"
                        (click)="setBookingStatus(booking, 4)"
                        [disabled]="isUpdatingStatus"
                      >
                        <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                        {{ 'completed' | transloco }}
                      </button>
                    </li>

                    <li *ngIf="booking.status != 3">
                      <button
                        class="bb-dropdown-item dropdown-item"
                        type="button"
                        (click)="openDeferredDatePopup(booking)"
                        [disabled]="isUpdatingStatus"
                      >
                        <i class="fa-solid fa-calendar-day" aria-hidden="true"></i>
                        {{ 'deferred' | transloco }}
                      </button>
                    </li>

                    <li *ngIf="booking.status == 3">
                      <button
                        class="bb-dropdown-item dropdown-item"
                        type="button"
                        (click)="openDeferredDatePopup(booking)"
                        [disabled]="isUpdatingStatus"
                      >
                        <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
                        {{ 'Change Deferred Date' | transloco }}
                      </button>
                    </li>

                    <li *ngIf="booking.status != 2">
                      <button
                        class="bb-dropdown-item dropdown-item"
                        type="button"
                        (click)="setBookingStatus(booking, 2)"
                        [disabled]="isUpdatingStatus"
                      >
                        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                        {{ 'rejected' | transloco }}
                      </button>
                    </li>

                    <li>
                      <hr class="dropdown-divider" />
                    </li>

                  </ng-container>

                  <li *ngIf="!isSubAdmin">
                    <button
                      class="bb-dropdown-item dropdown-item text-danger"
                      type="button"
                      (click)="deleteBooking(booking.id)"
                      [disabled]="isUpdatingStatus"
                    >
                      <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
                      {{ 'Delete' | transloco }}
                    </button>
                  </li>

                </ul>
              </div>
            </div>
          </div>

          <!-- Main -->
          <div class="booking-ticket-main">
            <div class="booking-avatar">
              <i class="fa-solid fa-user" aria-hidden="true"></i>
            </div>

            <div class="booking-client-info">
              <span>{{ 'client' | transloco }}</span>

              <h3>
                {{ getClientName(booking) }}
              </h3>

              <p *ngIf="booking.user?.email">
                <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                {{ booking.user.email }}
              </p>
            </div>
          </div>

          <!-- Service Highlight -->
          <div class="booking-service-strip">
            <span>
              <i class="fa-solid fa-stethoscope" aria-hidden="true"></i>
              {{ 'service' | transloco }}
            </span>

            <strong>
              {{ getServiceName(booking) }}
            </strong>
          </div>

          <!-- Details -->
          <div class="booking-ticket-details">

            <a
              class="booking-detail-chip booking-phone-chip"
              [attr.href]="booking.phone_number ? 'tel:' + booking.phone_number : null"
              [attr.aria-disabled]="!booking.phone_number ? 'true' : null"
              [attr.tabindex]="!booking.phone_number ? -1 : null"
            >
              <i class="fa-solid fa-phone" aria-hidden="true"></i>

              <span>
                {{ 'phone' | transloco }}
              </span>

              <strong>
                {{ booking.phone_number || '—' }}
              </strong>
            </a>

            <div class="booking-detail-chip">
              <i class="fa-solid fa-paw" aria-hidden="true"></i>

              <span>
                {{ 'pet' | transloco }}
              </span>

              <strong>
                {{ booking.pet_type ? (getPetTypeLabel(booking.pet_type) | transloco) : '—' }}
              </strong>
            </div>

            <div class="booking-detail-chip booking-detail-wide">
              <i class="fa-solid fa-calendar-check" aria-hidden="true"></i>

              <span>
                {{ 'Booking Date' | transloco }}
              </span>

              <strong>
                {{ formatDateTimeView(booking.booking_date) }}
              </strong>
            </div>

            <div class="booking-detail-chip booking-detail-wide">
              <i class="fa-solid fa-clock" aria-hidden="true"></i>

              <span>
                {{ 'Deferred Date' | transloco }}
              </span>

              <strong>
                {{ formatDateTimeView(booking.deferred_booking_date) }}
              </strong>
            </div>

            <div class="booking-detail-chip booking-detail-wide">
              <i class="fa-solid fa-globe" aria-hidden="true"></i>

              <span>
                {{ 'website_link' | transloco }}
              </span>

              <strong>
                {{ booking.from_website || 'website' }}
              </strong>
            </div>

          </div>

          <!-- Quick Actions -->
          <div
            class="booking-ticket-actions"
            *ngIf="!isFinalStatus(booking.status)"
          >
            <button
              *ngIf="booking.status != 1"
              type="button"
              class="bb-btn booking-action-approve"
              (click)="setBookingStatus(booking, 1)"
              [disabled]="isUpdatingStatus"
            >
              <i class="fa-solid fa-check" aria-hidden="true"></i>
              {{ 'approved' | transloco }}
            </button>

            <button
              type="button"
              class="bb-btn booking-action-defer"
              (click)="openDeferredDatePopup(booking)"
              [disabled]="isUpdatingStatus"
            >
              <i class="fa-solid fa-calendar-day" aria-hidden="true"></i>
              {{ booking.status == 3 ? ('Change Deferred Date' | transloco) : ('deferred' | transloco) }}
            </button>
          </div>

        </article>
      </div>

      <!-- Loading -->
      <div class="booking-mobile-loader" *ngIf="isLoadingMore">
        <span></span>
        <strong>{{ 'Loading...' | transloco }}</strong>
      </div>

    </ng-container>

    <ng-template #noBookingsTemplate>
      <div class="bb-empty-state bb-text-center">
        <app-nodata></app-nodata>
      </div>
    </ng-template>

  </div>
</section>

<!-- Deferred Date Popup -->
<div
  *ngIf="showDeferredPopup"
  class="bb-modal-backdrop booking-date-modal-backdrop"
>
  <div
    class="bb-modal-card booking-date-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="deferred-date-title"
  >

    <div class="bb-modal-header">
      <h4 id="deferred-date-title">
        {{ 'Change Deferred Date' | transloco }}
      </h4>

      <button
        type="button"
        class="bb-modal-close"
        (click)="closeDeferredPopup()"
        [disabled]="isUpdatingStatus"
        [attr.aria-label]="'close' | transloco"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <div class="booking-date-modal-body">
      <label class="bb-label">
        {{ 'Deferred Date' | transloco }}
      </label>

      <input
        class="bb-input"
        type="datetime-local"
        [(ngModel)]="deferredBookingDate"
        [min]="todayDateTime"
      />
    </div>

    <div class="booking-date-modal-actions">
      <button
        type="button"
        class="bb-btn bb-btn-secondary"
        (click)="closeDeferredPopup()"
        [disabled]="isUpdatingStatus"
      >
        {{ 'close' | transloco }}
      </button>

      <button
        type="button"
        class="bb-btn bb-btn-primary"
        (click)="submitDeferredDate()"
        [disabled]="isUpdatingStatus || !deferredBookingDate"
      >
        <span *ngIf="!isUpdatingStatus">
          {{ 'Submit' | transloco }}
        </span>

        <span *ngIf="isUpdatingStatus">
          {{ 'Loading...' | transloco }}
        </span>
      </button>
    </div>

  </div>
</div>